import { render, staticRenderFns } from "./menu-symptom.vue?vue&type=template&id=b9177124&scoped=true"
import script from "./menu-symptom.vue?vue&type=script&lang=js"
export * from "./menu-symptom.vue?vue&type=script&lang=js"
import style0 from "./menu-symptom.vue?vue&type=style&index=0&id=b9177124&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9177124",
  null
  
)

export default component.exports